import feathers from '@feathersjs/client'
import io from 'socket.io-client'

var feathersHost
if (!process.env.VUE_APP_FEATHERS_HOST) {
	feathersHost = 'http://localhost:3030'
	console.warn('VUE_APP_FEATHERS_HOST not set. Using ' + feathersHost)
} else {
	feathersHost = process.env.VUE_APP_FEATHERS_HOST
}

const socket = io(feathersHost, { transports: ['websocket'] })

const feathersClient = feathers()
	.configure(feathers.socketio(socket))
	.configure(feathers.authentication({ storage: window.localStorage }))

export default feathersClient
